// extracted by mini-css-extract-plugin
export default {"colorModeToggle":"colorModeToggle_Hg9V"};